import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAdd = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgAdd" data-sentry-source-file="add.tsx">
    <g clipPath="url(#add_svg__a)" data-sentry-element="g" data-sentry-source-file="add.tsx">
      <path fill="#263E6A" d="M11.5 18.5v-6h-6v-1h6v-6h1v6h6v1h-6v6z" data-sentry-element="path" data-sentry-source-file="add.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="add.tsx">
      <clipPath id="add_svg__a" data-sentry-element="clipPath" data-sentry-source-file="add.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="add.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgAdd;